<template>
    <div>
        <div class="m-b-md" v-for="(file, index) in files">
            <div class="row">
                <div class="col-md-12">
                    <h3 :class="hasError(file) ? 'text-danger' : ''">{{ displayFileName(file) }}</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 form-group" :class="file.error === 'styling' ? 'has-error' : ''">
                    <label class="pull-left">{{ translations.family }}</label>
                    <input class="pull-left form-control" type="text" v-model="file.family">
                </div>
                <div class="col-md-4 form-group">
                    <label class="pull-left">{{ translations.familyOnDevice }}</label>
                    <input class="pull-left form-control" type="text" v-model="file.family_on_device">
                </div>
                <button class="btn pull-right detail-button btn-white icon-btn mb-auto mt-auto" @click="handleRemove(index)">
                    <i class="fa-regular fa-trash"></i>
                </button>
            </div>
            <div class="row">
                <div class="col-md-4 form-group" :class="file.error === 'styling' ? 'has-error' : ''">
                    <label class="pull-left">{{ translations.weight }}</label>
                    <select class="pull-left form-control" v-model="file.weight">
                        <option value="normal">{{ translations.normal }}</option>
                        <option value="bold">{{ translations.bold }}</option>
                    </select>
                </div>
                <div class="col-md-4 form-group" :class="file.error === 'styling' ? 'has-error' : ''">
                    <label class="pull-left">{{ translations.style }}</label>
                    <select class="pull-left form-control" v-model="file.style">
                        <option value="normal">{{ translations.normal }}</option>
                        <option value="italic">{{ translations.italic }}</option>
                    </select>
                </div>
                <div class="col-md-4 pull-right form-group" v-if="global">
                    <label class="pull-left">{{ translations.packet }}</label>
                    <select class="form-control" v-model="file.packet">
                        <option :value="null">{{ translations.custom }}</option>
                        <option value="microsoft">{{ translations.microsoft }}</option>
                        <option value="google">{{ translations.google }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ERRORS} from "../fontVariables.js";

    export default {
        props: {
            files: {},
            global: {}
        },
        data() {
            return {
                fileCount: 0
            }
        },
        computed: {
            translations() {
                return {
                    title: Lang.langGet("Title"),
                    filename: Lang.langGet("Filename"),
                    fontAlreadyExists: Lang.langGet("A font with this name already exists!"),
                    fontAlreadyExistsInUpload: Lang.langGet("A font with the same name is already being uploaded!"),
                    fontDuplicateSettings: Lang.langGet("A font with the same configuration already exists!"),
                    fontDuplicateSettingsInUpload: Lang.langGet("A font with the same configuration is already being uploaded!"),
                    family: Lang.langGet("Family"),
                    weight: Lang.langGet("Weight"),
                    style: Lang.langGet("Style"),
                    familyOnDevice: Lang.langGet("Family on Device"),
                    example: Lang.langGet("Example Text"),
                    normal: Lang.langGet("Normal"),
                    bold: Lang.langGet("Bold"),
                    italic: Lang.langGet("Italic"),
                    packet: Lang.langGet("Packet"),
                    custom: Lang.langGet("Custom"),
                    microsoft: Lang.langGet("Microsoft (preferable in windows clients"),
                    google: Lang.langGet("Google (preferable on H5-clients)"),
                };
            }
        },
        watch: {
            files: function (list) {
                const size = _.size(list);

                if (size > 0 && this.fileCount !== size) {
                    this.fileCount = size;
                }
            }
        },
        methods: {
            handleRemove(index) {
                this.files.splice(index, 1);
            },
            hasError(file) {
                return file.error;
            },
            displayFileName(file) {
              if (file.error === ERRORS.DUPLICATE_NAME) return file.file_name + ' - ' + this.translations.fontAlreadyExists;
              if (file.error === ERRORS.DUPLICATE_NAME_IN_UPLOAD) return file.file_name + ' - ' + this.translations.fontAlreadyExistsInUpload;
              if (file.error === ERRORS.DUPLICATE_SETTINGS) return file.file_name + ' - ' + this.translations.fontDuplicateSettings;
              if (file.error === ERRORS.DUPLICATE_SETTINGS_IN_UPLOAD) return file.file_name + ' - ' + this.translations.fontDuplicateSettingsInUpload;
              return file.file_name;
            }
        }
    }
</script>
